import axios from 'axios';
import { getToken } from '../shared/src/services/user-info.service';

const mentoriaURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL as string;

const mentoriaApi = axios.create({
  baseURL: mentoriaURL,
});

mentoriaApi.interceptors.request.use(async (config: any) => {
	const token = getSessionToken();
	
	if (token && token !== "undefined" && !isTokenExpired(token)) {
	  // add Authorization header with JWT token
	  if (config.headers) {
		config.headers.Authorization = `Bearer ${token}`;
	  }
	} else {
	  // refresh token and add Authorization header with new token
	  const newToken = await refreshToken();
	  
	  if (config.headers) {
		config.headers.Authorization = `Bearer ${newToken}`;
	  }
	  setSessionToken(newToken);
	}
	return config;
  });
  
  function getSessionToken(): string | null {
	return sessionStorage.getItem('mentoria-token');
  }
  
  function setSessionToken(token: string): void {
	sessionStorage.setItem('mentoria-token', token);
  }
  
  function isTokenExpired(token: string): boolean {
	const decodedToken = JSON.parse(atob(token.split('.')[1]));
	const expiresAt = decodedToken.exp * 1000; // convert to milliseconds
	return expiresAt < Date.now();
  }
  
  async function refreshToken(): Promise<string> {
	const uid = sessionStorage.getItem('mentoria-uid');
	if (!uid) {
		throw new Error('No token available');
	}
	const idToken = await getToken(uid);
	if (!idToken || typeof idToken !== 'string') {
		throw new Error('No id_token returned from getToken');
	}
	return idToken;
  }
  
  export default mentoriaApi;